import React, { PureComponent } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAd, faAddressBook, faAddressCard, faAdjust, faAirFreshener, faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faAllergies, faAmbulance,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

library.add(faAd, faAddressBook, faAddressCard, faAdjust, faAirFreshener, faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faAllergies, faAmbulance);

export default class IconBox extends PureComponent {
  static propTypes = {
    icons: PropTypes.arrayOf(PropTypes.shape({
      class: PropTypes.string,
    })),
  };

  static defaultProps = {
    icons: [],
  };

  render() {
    const { icons } = this.props;

    return (
      <div className="catalog-items__wrap">
        <div className="catalog-items">
          {icons.map((item, i) => (
            <div className={`catalog-item jns-catalog p-t-20 p-b-20 ${item.type === 'awe' ? 'awesome' : ''}`} key={parseInt(i.toString(), 10)}>
              <div className="catalog-item__img-wrap h-auto m-0">
                {item.type === 'lnr' ? <span className={`fs-50 ${item.class}`} /> : <FontAwesomeIcon className="fs-50" icon={`${item.class}`} />}
              </div>
              <div className="text-center p-10">
                <h4 className="catalog-item__title">{item.class}</h4>
                {item.name ? <h4 className="catalog-item__title m-t-10">{item.name}</h4> : ''}
              </div>
            </div>
          ))}

        </div>
      </div>
    );
  }
}
